import { APP_URL } from './runtime';

const config = {
  baseURL: APP_URL,
  // getAllNews : 'news/getAllnews',
  getAllNews: "news/getAllnews",
  coin_detail_base_url: "https://bscscan.com/address/contract_address/",
};

export default config;
